import { getCurrentYear } from "@/common/utils/year"

const getPeriodDescription = (period: number | string): string => {
  const year = Number(period);

  if (Number.isNaN(year)) return '';

  const currentYear = getCurrentYear();

  if (year === currentYear) return '(оценка)'
  else if (year === currentYear + 1) return '(прогноз)'
  else return '';
}

export default getPeriodDescription